export default class checkTab {
    constructor() {
        $('body').on('keyup.tabwatcher', function(e) {
            if (e.which == 9) {
                e.preventDefault();
                $('body').addClass('has-tabbed');
                $('body').off('keyup.tabwatcher')
            }
        });
    }
}